'use strict'
import email from './email'
import number from './number'
import string  from './string'

export default {email, number , string}